import React, { useState, useMemo, useEffect } from 'react'
import { Grid, TextField, Typography, Autocomplete, Chip } from '@material-ui/core'
import genesList from 'src/constants/genes.json'

function GeneFilterModal({ value = '', onChange, onClose }) {
  const [inputValue, setInputValue] = useState('')

  // Debug logging
  console.log('GeneFilterModal received value:', value, 'type:', typeof value)

  // Split the input string into an array of gene names
  const selectedGenes = useMemo(() => {
    if (!value || typeof value !== 'string') return []
    return value.split(',').filter((gene) => gene.trim() !== '')
  }, [value])

  // Local state for selected genes (separate from prop)
  const [localSelectedGenes, setLocalSelectedGenes] = useState(selectedGenes)

  // Update local state when prop changes
  useEffect(() => {
    setLocalSelectedGenes(selectedGenes)
  }, [selectedGenes])

  // Update parent state whenever localSelectedGenes changes
  useEffect(() => {
    const genesString = localSelectedGenes.join(',')
    console.log('Gene filter values changed:', genesString)
    onChange(genesString)
  }, [localSelectedGenes, onChange])

  // Filter genes list based on input value
  const filteredOptions = useMemo(() => {
    const searchTerm = inputValue.toLowerCase()
    if (searchTerm.length < 1) return [] // Only show suggestions after 1 character
    return genesList
      .filter((gene) => gene.toLowerCase().includes(searchTerm) && !localSelectedGenes.includes(gene))
      .slice(0, 100) // Limit to first 100 matches
  }, [inputValue, localSelectedGenes])

  const handleChange = (event, newValue) => {
    // Update local state only
    console.log('Gene filter changed locally:', newValue)
    setLocalSelectedGenes(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Gene Names Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Enter gene names to filter variants. You can search and select multiple genes.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          options={filteredOptions}
          value={localSelectedGenes}
          onChange={handleChange}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue)
          }}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" placeholder="Type to search genes" fullWidth />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => <Chip key={index} label={option} {...getTagProps({ index })} size="small" />)
          }
          filterOptions={(options) => options} // Disable built-in filtering
          loading={inputValue.length > 1 && filteredOptions.length === 0}
          loadingText="No matching genes"
          noOptionsText="Type to search genes"
          freeSolo
          size="small"
        />
      </Grid>
    </Grid>
  )
}

export default GeneFilterModal
